import React, { useEffect, useState } from 'react';
import { NamedVersionSelection } from './NamedVersionSelection';
import { SelectItem } from '../../../../types';
import { filterSelectItems } from '../../../../utils';
import { LoadingPage } from '../../../Shared';
import { IModelsApi } from '../../../../apis';

export interface NamedVersionSelectionContainerProps {
  iModelId: string;
  selected?: string;
  setNamedVersionId: (namedVersionId: string) => any;
}

export function NamedVersionSelectionContainer({
  iModelId,
  selected,
  setNamedVersionId,
}: NamedVersionSelectionContainerProps): JSX.Element {
  const [items, setItems] = useState<SelectItem[]>([]);
  const [displayedItems, setDisplayedItems] = useState<SelectItem[]>([]);
  const [filter, setFilter] = useState<string>('');
  const [loading, setLoading] = useState(true);

  const init = async () => {
    let namedVersions: SelectItem[] = (
      await IModelsApi.fetchIModelChangesets(iModelId)
    ).map(
      namedVersion =>
        ({
          value: namedVersion.instanceId,
          text: namedVersion.name,
          onClick: () => setNamedVersionId(namedVersion.instanceId),
          date: namedVersion.createdDate,
        } as SelectItem)
    );

    if (namedVersions.length !== 0) {
      const latestNamedVersion = {
        value: 'latest-named-version',
        text: 'Latest changes',
        onClick: () => setNamedVersionId('latest-named-version'),
      };

      namedVersions = [latestNamedVersion, ...namedVersions];
    }

    selected ?? setNamedVersionId(namedVersions[0]?.value);
    setItems(namedVersions);
    setDisplayedItems(namedVersions);
    setLoading(false);
  };

  useEffect(() => {
    init().catch(error => console.error(error));
  }, []);

  useEffect(() => {
    setDisplayedItems(filterSelectItems(items, filter));
  }, [filter]);

  const onSearch = async (input: string = '') => {
    setFilter(input);
  };

  const onClear = async () => {
    setFilter('');
  };

  const onChange = async (input: string = '') => {
    setFilter(input);
  };

  if (loading) {
    return <LoadingPage subtext='Fetching named versions...' fullscreen />;
  }

  return (
    <NamedVersionSelection
      items={displayedItems}
      selected={selected}
      onSearch={onSearch}
      onClear={onClear}
      onChange={onChange}
    />
  );
}
